import DOMPurify from 'isomorphic-dompurify';

// Works like a normal div element, but allows you to set the innerHTML with a string.
// The string will be sanitized with DOMPurify.
// This way we can safely render HTML content from the CMS without risking XSS attacks.

type DivProps = React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement>;

type SanitizedMarkupProps = Omit<DivProps, 'dangerouslySetInnerHTML'> & {
  html: string,
  allowedTags?: string[], // We can whitelist tags here for tags that technically are a security risk, but are allowed by the CMS since KrisKras wont use them maliciously.
};

export function SanitizedMarkup({ html, allowedTags, ...props }: SanitizedMarkupProps) {
  const cleanHtml = (allowedTags != null && allowedTags.length > 0)
    ? DOMPurify.sanitize(html, { ALLOWED_TAGS: allowedTags })
    : DOMPurify.sanitize(html);

  return (
    <span dangerouslySetInnerHTML={ { __html: cleanHtml } } { ...props }>
    </span>
  );
}
